module.exports = __webpack_public_path__ + "img/04.a2505961.png";